import * as _ from 'lodash';
import IGridicsUseTag = ZoneIQCalibration.IGridicsUseTag;
import { GridicsUseTag } from 'src/app/interfaces/gridics-use-tag.interface';

export class GridicsUseTagModel implements GridicsUseTag {
    Id?: number;
    GridicsUse: string;
    CalibrationUsesTypeId?: number;
    CreatedOn?: string;
    ModifiedOn?: string;

    constructor(data: IGridicsUseTag) {
        Object.assign(this, _.pick(data, ['Id', 'GridicsUse', 'CalibrationUsesTypeId', 'CreatedOn', 'ModifiedOn']));
    }

    static factory(data: IGridicsUseTag): GridicsUseTagModel {
        return new GridicsUseTagModel(data);
    }
}
